<script>
import appConfig from '@src/app.config'

export default {
  metaInfo: {
    // All subcomponent titles will be injected into this template.
    titleTemplate(title) {
      title = typeof title === 'function' ? title(this.$store) : title
      return title ? `${title} | ${appConfig.title}` : appConfig.title
    },
  },
}
</script>

<template>
  <div id="app">
    <!--
    Even when routes use the same component, treat them
    as distinct and create the component again.
    -->
    <VFadeTransition mode="out-in">
      <RouterView />
    </VFadeTransition>
  </div>
</template>

<style lang="scss">
@import '~nprogress/nprogress.css';
$gold: #c5a46d;

#nprogress {
  .bar {
    background: $gold;
  }
  .peg {
    box-shadow: 0 0 10px $gold, 0 0 5px $gold;
  }
  // stylelint-disable-next-line selector-class-pattern
  .spinner-icon {
    border-top-color: $gold;
    border-left-color: $gold;
  }
}
</style>
